// DISABLE UNUSED-VARS CHECK AS THE ENUM IS NOT REFERENCED DIRECTLY BUT MAPPED INTO AN ARRAY AND REFERENCED
/* eslint no-unused-vars: 0 */
export enum TreatmentOptions {
  fullCode = 'Full Code - All Treatment & No Limitations in Care',
  fullCodeBipapInt = 'Full Code with trial of BiPAP then intubation',
  fullCodeBipap = 'Full Code with Trial of BiPAP and no intubation',
  fullCodeACLS15 = 'Full Code and Trial of ACLS for 15 minutes',
  fullCodeACLS15BipapInt = 'Full Code and Trial of ACLS for 15 minutes with BiPAP then intubation',
  fullCodeACLS15Bipap = 'Full Code and Trial of ACLS for 15 minutes with BiPAP and no intubation',
  aggressiveBipapInt = 'Full and Aggressive treatment until cardiac arrest with BiPAP then intubation',
  aggressiveBipap = 'Full and Aggressive treatment until cardiac arrest with BiPAP and no intubation',
  clarifications = 'Clarification in Treatment DNR',
  eol = 'DNR/CMO/Allow Natural Death',
}

export type TreatmentOptionsType = keyof typeof TreatmentOptions;
